import dynamic from "next/dynamic";

export const FAQs = dynamic(() => import("./component"));
